import React, { useState, useEffect } from "react";

const SimpleModalVideo = ({
  channel = "youtube",
  videoId,
  isOpen = false,
  onClose,
  className = "",
}) => {
  const [isModalOpen, setIsModalOpen] = useState(isOpen);

  useEffect(() => {
    setIsModalOpen(isOpen);
  }, [isOpen]);

  const handleClose = () => {
    setIsModalOpen(false);
    if (onClose) onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const getVideoUrl = () => {
    if (channel === "youtube") {
      return `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;
    } else if (channel === "vimeo") {
      return `https://player.vimeo.com/video/${videoId}?autoplay=1`;
    }
    return "";
  };

  if (!isModalOpen) return null;

  return (
    <div
      className={`modal-video-overlay ${className}`}
      onClick={handleBackdropClick}
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(0, 0, 0, 0.8)",
        zIndex: 10000,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <div
        className="modal-video-container"
        style={{
          position: "relative",
          width: "90%",
          maxWidth: "800px",
          height: "auto",
          aspectRatio: "16/9",
        }}
      >
        <button
          className="modal-video-close"
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "-40px",
            right: "0",
            background: "none",
            border: "none",
            color: "white",
            fontSize: "30px",
            cursor: "pointer",
            zIndex: 10001,
          }}
        >
          ×
        </button>
        <iframe
          src={getVideoUrl()}
          frameBorder="0"
          allow="autoplay; encrypted-media"
          allowFullScreen
          title="Video Player"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
          }}
        />
      </div>
    </div>
  );
};

export default SimpleModalVideo;
